import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const NotSureIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-notSure"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.4623 28.1565C20.8463 28.5315 20.8463 29.4685 21.4623 29.8435L23.5373 31.1055 25.6133 32.3685C26.2293 32.7425 27.0003 32.2745 27.0003 31.5245L27.0003 29.0005 27.0003 26.4755C27.0003 25.7255 26.2293 25.2575 25.6133 25.6315L23.5373 26.8945 21.4623 28.1565ZM46.5377 28.1565C47.1537 28.5315 47.1537 29.4685 46.5377 29.8435L44.4627 31.1055 42.3867 32.3685C41.7707 32.7425 40.9997 32.2745 40.9997 31.5245L40.9997 29.0005 40.9997 26.4755C40.9997 25.7255 41.7707 25.2575 42.3867 25.6315L44.4627 26.8945 46.5377 28.1565Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="26 30 42 30 42 28 26 28"
        />
        <path
          d="M32.0219,16.4807 C32.0219,15.9927 32.1649,15.6167 32.4519,15.3507 C32.7379,15.0847 33.1589,14.9527 33.7159,14.9527 C34.2499,14.9527 34.6609,15.0867 34.9459,15.3547 C35.2329,15.6227 35.3759,15.9987 35.3759,16.4807 C35.3759,16.9627 35.2279,17.3377 34.9299,17.6037 C34.6339,17.8677 34.2289,17.9997 33.7159,17.9997 C33.1859,17.9997 32.7709,17.8687 32.4709,17.6067 C32.1729,17.3437 32.0219,16.9687 32.0219,16.4807 L32.0219,16.4807 Z M32.3679,13.6957 L32.3679,13.0117 C32.3679,12.4907 32.4739,12.0527 32.6889,11.6937 C32.9019,11.3367 33.2819,10.9877 33.8279,10.6477 C34.2609,10.3777 34.5719,10.1327 34.7619,9.9147 C34.9519,9.6987 35.0469,9.4487 35.0469,9.1687 C35.0469,8.9457 34.9449,8.7677 34.7429,8.6387 C34.5389,8.5087 34.2749,8.4437 33.9479,8.4437 C33.1399,8.4437 32.1959,8.7277 31.1159,9.2957 L29.9999,7.1307 C31.3319,6.3767 32.7229,5.9997 34.1719,5.9997 C35.3659,5.9997 36.3019,6.2607 36.9799,6.7807 C37.6609,7.2997 37.9999,8.0087 37.9999,8.9047 C37.9999,9.5467 37.8479,10.1027 37.5459,10.5727 C37.2449,11.0417 36.7619,11.4857 36.0979,11.9057 C35.5359,12.2657 35.1839,12.5297 35.0429,12.6967 C34.9019,12.8647 34.8299,13.0617 34.8299,13.2887 L34.8299,13.6957 L32.3679,13.6957 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M34,1 C27.9247153,1 23,5.92471525 23,12 C23,18.0752847 27.9247153,23 34,23 C40.0752847,23 45,18.0752847 45,12 C45,5.92471525 40.0752847,1 34,1 Z M34,3 C38.9707153,3 43,7.02928475 43,12 C43,16.9707153 38.9707153,21 34,21 C29.0292847,21 25,16.9707153 25,12 C25,7.02928475 29.0292847,3 34,3 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
